<template>
  <app-layout>
    <template #header>
      <AppHead :title="title"/>
      <h3 class="title my-2">Shipments</h3>
    </template>

    <div class="mt-4">
      <ul class="nav nav-tabs nav-justified">
        <li class="nav-item">
          <inertia-link :class="['nav-link', {active: tab === 'toolflow'}]"
                        :href="route('shipments.list', {tab: 'toolflow'})">
            Tool Flow
          </inertia-link>
        </li>
        <li class="nav-item" v-if="$page.props.auth.user.mtd_use_customer_direct">
          <inertia-link :class="['nav-link', {active: tab === 'customerDirect'}]"
                        :href="route('shipments.list', {tab: 'customerDirect'})">
            Customer Direct
          </inertia-link>
        </li>
        <li class="nav-item">
          <inertia-link :class="['nav-link', {active: tab === 'history'}]"
                        :href="route('shipments.list', {tab: 'history'})">
            History
          </inertia-link>
        </li>
      </ul>
      <card class="border-top-0">
        <div class="tab-content mt-2">
          <div v-if="tab === 'toolflow'" class="tab-pane fade show active" role="tabpanel">
            <ToolFlow :tools="data"></ToolFlow>
          </div>

          <div v-if="tab === 'customerDirect'" class="tab-pane fade show active" role="tabpanel">
            <CustomerDirect :orders="data"></CustomerDirect>
          </div>

          <div v-if="tab === 'history'" class="tab-pane fade show active" role="tabpanel">
            <History :shipments="data"></History>
          </div>
        </div>
      </card>
    </div>
  </app-layout>
</template>

<script>
import AppHead from '@/Shared/AppHead'
import AppLayout from '@/Layouts/AppLayout'
import ToolFlow from '@/Pages/Shop/Account/ToolFlow'
import CustomerDirect from '@/Pages/Shop/Account/CustomerDirect'
import History from '@/Pages/Shop/Account/History'
import ReportShipping from '@/Components/Products/ReportShipping'

export default {
  components: {
    AppHead,
    AppLayout,
    CustomerDirect,
    History,
    ToolFlow,
    ReportShipping
  },
  props: {
    tab: String,
    data: Array,
    notes: Array
  },
  computed: {
    title() {
      if (this.tab === 'customerDirect') return 'Customer Direct Shipments';
      if (this.tab === 'history') return 'Shipments History';
      return 'Tool Flow';
    }
  },
}
</script>
